import React from 'react';

const DMTag = ({ color = '#757575', width = 20, height = 20, ...rest }, ref) => {
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}>
      <path
        d="M3.3335 8.33463C3.3335 5.19194 3.3335 3.62059 4.30981 2.64428C5.28612 1.66797 6.85747 1.66797 10.0002 1.66797C13.1429 1.66797 14.7142 1.66797 15.6905 2.64428C16.6668 3.62059 16.6668 5.19194 16.6668 8.33464V11.668C16.6668 14.8107 16.6668 16.382 15.6905 17.3583C14.7142 18.3346 13.1429 18.3346 10.0002 18.3346C6.85747 18.3346 5.28612 18.3346 4.30981 17.3583C3.3335 16.382 3.3335 14.8107 3.3335 11.668V8.33463Z"
        stroke={color}
        strokeWidth="1.25"
      />
      <path d="M12.5 15.832H7.5" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
      <path
        d="M13.9571 1.98047L13.8871 2.08561C13.257 3.03068 12.942 3.50323 12.4818 3.78916C12.3903 3.84601 12.2953 3.89689 12.1972 3.94148C11.7041 4.16573 11.1361 4.16573 10.0003 4.16573C8.86445 4.16573 8.29653 4.16573 7.80339 3.94148C7.70533 3.89689 7.61026 3.84601 7.51876 3.78916C7.05863 3.50323 6.7436 3.03069 6.11355 2.08561L6.04346 1.98047"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default React.forwardRef(DMTag);
